import api from "@/apis/staff";
import store from "@/store";

/**
 * テーブルソート関連
 */
const TableSorter = {
  /**
   * サイズ表示順マップをAPIから取得してstoreに保存
   * @returns
   */
  async fetchSizeDisplayOrderMap(): Promise<void> {
    const cachedMap = store.getSizeDisplayOrderMap();
    if (cachedMap) return;

    const response = await api.post("/product/size-display-orders/search", {});
    const list = response.data.results?.sizeDisplayOrderList ?? [];
    const map: Record<string, number> = {};
    list.forEach((e: { sizeCode: string; displayOrder: number }) => {
      map[e.sizeCode] = e.displayOrder;
    });
    store.setSizeDisplayOrderMap(JSON.stringify(map));
  },

  /**
   * 行の値を比較
   * @param a 比較対象の値1
   * @param b 比較対象の値2
   * @param isAscent 昇順の場合true、降順の場合false
   * @returns
   */
  compareRow(a: any, b: any, isAscent: boolean): number {
    const multiplier = isAscent ? 1 : -1;
    if (a > b) return 1 * multiplier;
    if (a < b) return -1 * multiplier;
    return 0;
  },

  /**
   * デフォルトのソート関数を生成
   * @param sortTarget ソート対象のプロパティ名
   * @param isAscent 昇順の場合true、降順の場合false
   * @returns
   */
  defaultSorter(sortTarget: string, isAscent: boolean): (a: any, b: any) => number {
    return (a, b) => {
      const multiplier = isAscent ? 1 : -1;
      if (a[sortTarget] > b[sortTarget]) return 1 * multiplier;
      if (a[sortTarget] < b[sortTarget]) return -1 * multiplier;
      return 0;
    };
  },

  /**
   * サイズ表示順のソート関数を生成
   * サイズコードをサイズ表示順マスタの値でソートする
   * @param isAscent 昇順の場合true、降順の場合false
   * @returns
   */
  sizeSorter(isAscent: boolean): (a: any, b: any) => number {
    const sizeMap = store.getSizeDisplayOrderMap() ?? {};
    return (a, b) => {
      const aSizeOrder = sizeMap[a["sizeCode"]] ?? Number.POSITIVE_INFINITY;
      const bSizeOrder = sizeMap[b["sizeCode"]] ?? Number.POSITIVE_INFINITY;
      const s = TableSorter.compareRow(aSizeOrder, bSizeOrder, isAscent);
      if (s !== 0) return s;
      return TableSorter.compareRow(a["sizeCode"], b["sizeCode"], isAscent);
    };
  },

  /**
   * ソート対象に応じたソート関数を取得
   * sizeCodeの場合はサイズ表示順でソート、それ以外はデフォルトソート
   * @param sortTarget ソート対象のプロパティ名
   * @param isAscent 昇順の場合true、降順の場合false
   * @returns
   */
  getSorter(sortTarget: string, isAscent: boolean): (a: any, b: any) => number {
    if (sortTarget === "sizeCode") {
      return TableSorter.sizeSorter(isAscent);
    }
    return TableSorter.defaultSorter(sortTarget, isAscent);
  },

};

export default TableSorter;
